import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UsersApiService {

    constructor(private http: HttpClient) {
    }

    public getUsers(): Observable<any> {
        return this.http.get('/api/user');
    }

    public getUser(id): Observable<any> {
        return this.http.get('/api/user/' + id);
    }

    public updateUser(id, data): Observable<any> {
        return this.http.put('/api/user/' + id, data);
    }

    public createUser(data): Observable<any> {
        return this.http.post('/api/user', data);
    }

    public getBranches(): Observable<any> {
        return this.http.get('/api/branch');
    }

    public getRoles(): Observable<any> {
        return this.http.get('/api/roles');
    }

    public postBranch(data): Observable<any> {
        return this.http.post('/api/user-branch', data);
    }

    public deleteBranch(data): Observable<any> {
        return this.http.delete('/api/user-branch', {params: data});
    }
}
